import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";

export default function PaymentPage() {
    const [searchParams] = useSearchParams();
    const [ready, setReady] = useState(false);
    const [accepted, setAccepted] = useState(false);

    const sessionId = searchParams.get("session");

    useEffect(() => {
        if (!sessionId) return;

        const script = document.createElement("script");
        script.src =
            "https://ap-gateway.mastercard.com/static/checkout/checkout.min.js";
        script.setAttribute("data-error", "errorCallback");
        script.setAttribute("data-cancel", "cancelCallback");

        script.onload = () => setReady(true);

        document.body.appendChild(script);

        window.errorCallback = (error) => {
            alert("Payment Error ❌");
            console.log(error);
        };

        window.cancelCallback = () => {
            alert("Payment Cancelled ❌");
        };
    }, [sessionId]);

    const startPayment = () => {
        if (!accepted) {
            alert("⚠️ Please accept Terms & Conditions");
            return;
        }

        if (!window.Checkout || !sessionId) {
            alert("Payment not ready");
            return;
        }

        window.Checkout.configure({
            session: { id: sessionId },
        });

        window.Checkout.showPaymentPage();
    };

    return (
        <div className="
        w-full
        min-h-screen
        bg-[#FCFAF5]
        dark:bg-gray-950
    ">

            <PageHeader
                title="Secure Payment"
                subtitle="Your transaction is encrypted and securely processed"
            />


            <section className="
            flex
            items-center
            justify-center
            px-6
            py-20
        ">

                <div
                    className="
                    w-full
                    max-w-lg

                    bg-white
                    dark:bg-gray-900

                    border
                    border-[#DDD2BA]
                    dark:border-gray-800

                    rounded-[40px]

                    p-8
                    md:p-10

                    shadow-xl

                    hover:shadow-2xl

                    transition-all
                    duration-300
                "
                >

                    {/* TITLE */}

                    <div className="
                    w-16
                    h-16

                    mx-auto

                    rounded-2xl

                    bg-[#0F766E]

                    text-white

                    flex
                    items-center
                    justify-center

                    text-3xl

                    shadow-md
                ">
                        🔒
                    </div>


                    <h2 className="
                    mt-6
                    text-2xl
                    font-serif
                    font-bold
                    text-center

                    text-gray-900
                    dark:text-white
                ">
                        Secure Payment Gateway
                    </h2>


                    <p className="
                    text-sm
                    text-center

                    text-gray-600
                    dark:text-gray-400

                    mt-3

                    leading-relaxed
                ">
                        Your payment is encrypted and securely processed through
                        Mastercard Payment Gateway Services.
                    </p>



                    {/* SECURITY BOX */}

                    <div className="
                    mt-6

                    bg-[#FCFAF5]

                    dark:bg-gray-800

                    border
                    border-[#DDD2BA]
                    dark:border-gray-700

                    rounded-2xl

                    p-4
                ">

                        <p className="
                        text-sm
                        text-gray-600
                        dark:text-gray-300
                    ">
                            ✓ Secure encrypted transaction
                        </p>

                        <p className="
                        text-sm
                        text-gray-600
                        dark:text-gray-300
                        mt-2
                    ">
                            ✓ Protected by Mastercard security
                        </p>

                    </div>




                    {/* CHECKBOX */}

                    <div className="
                    flex
                    items-start
                    gap-3

                    mt-6
                ">

                        <input
                            type="checkbox"
                            checked={accepted}
                            onChange={() => setAccepted(!accepted)}
                            className="
                            mt-1
                            w-4
                            h-4

                            accent-[#0F766E]
                        "
                        />


                        <label className="
                        text-sm

                        text-gray-600
                        dark:text-gray-400

                        leading-relaxed
                    ">

                            I agree to the{" "}

                            <Link
                                to="/terms-conditions"
                                className="
                                text-[#0F766E]
                                dark:text-[#B89442]

                                font-semibold

                                hover:underline
                            "
                            >
                                Terms & Conditions
                            </Link>


                            {" "}and{" "}


                            <Link
                                to="/privacy-policy"
                                className="
                                text-[#0F766E]
                                dark:text-[#B89442]

                                font-semibold

                                hover:underline
                            "
                            >
                                Privacy Policy
                            </Link>

                        </label>

                    </div>





                    {/* BUTTON */}

                    <button
                        onClick={startPayment}
                        disabled={!ready || !accepted}
                        className={`
        w-full
        mt-8
        py-3.5
        rounded-full
        font-semibold
        text-white
        transition-all
        duration-300
        shadow-lg

        ${!ready || !accepted
                                ? "bg-gray-400 cursor-not-allowed"
                                : `
                    bg-[#0F766E]
                    hover:bg-[#B89442]
                    hover:-translate-y-1
                    hover:shadow-xl
                `
                            }
    `}
                    >
                        {ready
                            ? "Proceed to Secure Payment"
                            : "Preparing Secure Checkout..."
                        }
                    </button>


                </div>

            </section>

        </div>
    );
}